import useTitanApp from "../../../hooks/useTitanApp";
import {
    deletePatientAllergies,
    setCurrentPatientAllergyToDelete,
    getPatientAllergies,
} from "../../../dispatchers/patientDispatchers";
import { Modal } from "react-bootstrap";
import { IoClose } from "react-icons/io5";
import "../../../assets/css/PatientDeleteAllergiesModal.scss";
import { LuHeart } from "react-icons/lu";

export default function PatientDeleteAllergiesModal() {
    const { appState, patientState } = useTitanApp();
    const { darkMode } = appState || {};
    const {
        selectedPatientDetails,
        showDeleteAllergiesModal,
        deletePatientAllergiesLoader,
        selectedPatientAllergy,
        consultationId
    } = patientState || {};

    const closeModal = () => {
        setCurrentPatientAllergyToDelete(null);
    };

    const handleDeleteClick = async () => {
        if (!selectedPatientAllergy) return;

        try {
            let lstAllergies = [];
            const allergies = {
                allergyName: selectedPatientAllergy?.allergyName,
                severity: selectedPatientAllergy?.severity === "" ? null : Number(selectedPatientAllergy?.severity),
                typicalReaction: selectedPatientAllergy?.typicalReaction,
                additionalNotes: selectedPatientAllergy?.additionalNotes,
            };
            lstAllergies.push(allergies);
            const patientAllergies = {
                consultationId,
                patientId: selectedPatientDetails?.patientID,
                allergies: lstAllergies,
            };
            await deletePatientAllergies(patientAllergies)
            closeModal();
            await getPatientAllergies(selectedPatientDetails?.patientID);
            setCurrentPatientAllergyToDelete(null);
        } catch (error) {
            console.error("Error in deleting patient allergies:", error);
        }
    };
    return (
        <Modal
            show={showDeleteAllergiesModal}
            onHide={closeModal}
            centered
            backdrop="static"
            dialogClassName="pc-modal-delete-allergies delete-allergies"
            size="md"
        >
            <div className="header">
                <div className="info">
                    <div className="icon">
                        <LuHeart color={darkMode ? "#bdbdbd" : "#0a0a0a"} />
                    </div>
                    <p className="label">
                        Delete Allergy
                    </p>
                </div>
                <IoClose
                    size={20}
                    color={darkMode ? "#bdbdbd" : "#7c7c7c"}
                    onClick={closeModal}
                />
            </div>
            <div className="body">
                <div>
                    <p>
                        Are you sure you want to delete the allergy {selectedPatientAllergy ? `"${selectedPatientAllergy?.allergyName}"` : "this"}? Do you want to continue?
                    </p>
                </div>
                <div className="pc-delete-allergies-footer-actions">
                    <button className="cancel" type="button" onClick={closeModal}>
                        Cancel
                    </button>
                    <button
                        className="done"
                        type="submit"
                        disabled={deletePatientAllergiesLoader}
                        onClick={() => handleDeleteClick()}
                    >
                        {deletePatientAllergiesLoader === true ? "Deleting..." : "Delete"}
                    </button>
                </div>
            </div>
        </Modal>
    );
}
